module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_fails.js